import { RootState } from "@/store/store";
import { resourcesMasterGridIdByResourceTypeSelector } from "@/store/resources-grid/selectors/grid/resourcesMasterGridIdByResourceTypeSelector";
import { selectedResourcesByMasterIdSelector } from "@/store/resources-grid/selectors/grid/selection/selectedResourcesByMasterIdSelector";
import { resourceDetailsGeneralContentDetailsFromResourceGenerator } from "@/components/pages/common/resource-details/components/content/general-content/components/details/resource-details-general-content-details-generator/resourceDetailsGeneralContentDetailsFromResourceGenerator";
import { ResourceType } from "@/services/cloudchipr.api";
import { resourceSmartTagsColumnDefColId } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/smartTagsColumnDef";

export const resourceGridStringifiedColumnsByResourceTypeSelector = (
  state: RootState,
  resourceType: ResourceType,
) => {
  const masterGridId = resourcesMasterGridIdByResourceTypeSelector(
    state,
    resourceType,
  );

  if (!masterGridId) {
    return null;
  }

  const selectedResources = selectedResourcesByMasterIdSelector(
    state,
    masterGridId,
  );

  if (!selectedResources) {
    return null;
  }

  return selectedResources
    .map((resource) => {
      return resourceDetailsGeneralContentDetailsFromResourceGenerator(
        resource ?? null,
        [resourceSmartTagsColumnDefColId],
        true,
        true,
      );
    })
    .map((data) => {
      return data.reduce(
        (acc, item) => {
          acc[item.title] = item.value;

          return acc;
        },
        {} as Record<string, any>,
      );
    });
};
